import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import defaultProps from 'recompose/defaultProps.js';
import { Switch, Redirect } from 'react-router-dom';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest } from 'cccisd-laravel-assignment';
import { ResourceCenter } from 'cccisd-laravel-resources';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
import About from './pages/About';
import Course from './pages/Course';
import Welcome from './pages/Welcome';

// Laravel packages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';
// Bind MainLayout by default
const AppRoute = defaultProps({ layout: MainLayout })(Route);
const MainLayoutFluid = defaultProps({ className: 'container-fluid' })(MainLayout);
const MainLayoutSecondaryNav = defaultProps({ showSecondaryNav: true })(MainLayout);
const MainLayoutFluidSecondaryNav = defaultProps({
    className: 'container-fluid',
    showSecondaryNav: true,
})(MainLayout);
let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;
const componentMatch = {
    AppdefManage,
    Welcome,
    Course,
};
const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};
export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }
            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    // exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} />
        <AppRoute path="/resources/:tab?/:id?" component={ResourceCenter} componentProps={{ handle: 'default' }} />
        <AppRoute path="/about" component={About} />
        <AppRoute
            path={['/quest/preview', '/d', '/survey']}
            component={props =>
                Fortress.user.acting.role.handle === 'learner' ? <Redirect to="/study" /> : <Quest {...props} />
            }
            layout={QuestLayout}
        />
        <AppRoute path="/account" component={Nexus} />
        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />
        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
